"use client";

import { Typography } from "antd/lib";
import Image from "next/image";
import screenerIcon from "@/asset/images/screener-icon.svg";
import portfolioIcon from "@/asset/images/portfolio-icon.svg";

export default function ExploreProducts() {
  return (
    <div className="rounded-xl p-4 border border-gray-200 h-[220px] mt-4">
      <Typography.Title level={4} className="!mb-4">
        Explore our products
      </Typography.Title>

      <div className="space-y-4">
        <div className="flex items-start gap-3 pb-4 border-b border-gray-200">
          <Image src={screenerIcon} alt="Screener" width={32} height={32} />
          <div>
            <Typography.Title level={5} className="!mb-0">
              Klarda Screener
            </Typography.Title>
            <Typography.Text className="text-gray-500 text-sm">
              Flexible tool to filter indicators for crypto
            </Typography.Text>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <Image src={portfolioIcon} alt="Portfolio" width={32} height={32} />
          <div>
            <Typography.Title level={5} className="!mb-0">
              Klarda Portfolio
            </Typography.Title>
            <Typography.Text className="text-gray-500 text-sm">
              A Professional Crypto portfolio management
            </Typography.Text>
          </div>
        </div>
      </div>
    </div>
  );
}
